const ExampleList = () => import('Views/example/example-list');
const ExampleDetail = () => import('Views/example/example-detail');

export default[
  { path: '/example-list', component: ExampleList },
  { path: '/example-detail/:id', component: ExampleDetail },
];



// WEBPACK FOOTER //
// ./src/router/example.js